export enum Residence {
  OwnHouse = 'Own house',
  OwnApartment = 'Own apartment',
  Rental = 'Rental',
  PartnersHouse = 'Partners House',
  CompanyOwnedFlat = 'Company owned flat',
  Cohabitant = 'Cohabitant',
  Tenant = 'Tenant',
  CooperativeApartment = 'Cooperative apartment',
  WithParents = 'With parents',
}

export enum ResidencePermit {
  No = 0,
  Temporary = 1,
  Permanent = 2,
  ProofRegistration = 3,
  ProofRightToUnlimited = 4,
}
